export const alertEn = {
  'invalid-username-format-error': 'Invalid username format',
  'invalid-password-format-error': 'Invalid password format',
  'invalid-cuurent-password-format-error': 'Invalid current password format',
  'errors-current-password-required': 'Current password is required',
  'errors-incorrect-current-password':
    'Incorrect current password, please try again.',
  'errors-password-previously-used':
    'Please create a password that has not been used.',
  'invalid-password-confirmation-error':
    'Password and password confirmation does not match',
  'missing-username-error':
    'Please enter your username before submitting the form',
  'invalid-form-submit-error':
    'Form contains invalid or blank inputs, please correct them before submitting',
  'register-cardholder-failed-alert':
    'Failed to register Cardholder, please try again',
  'register-cardholder-success-alert':
    'Card succesfully registered, logging in...',
  'password-reset-success-alert':
    'Password has been reset. You may now login using your new password.',
  'login-failed-error': 'Failed to log in user',
  'exceeds-available-amount-alert':
    'Transfer amount exceeds available account balance.',
  'refresh-failed-error':
    'Failed to refresh the session. Please try again or wait to be logged out.',
  'pin-retrieve-error':
    'Error while retrieving pin. Please retry or contact your Account Manager if you continue to have issues.',
  'account_locked':
    'Account is locked due to failed attempts. Try again in {time}',
  'invalid_credentials':
    'Invalid username or password. {attempts} attempts remaining',
  'mfa-status-failed':
    'Failed to retrieve MFA status. Please try again.',
  'mfa-setup-failed':
    'Failed to complete MFA setup. Please verify your code and try again.',
  'mfa-verification-failed':
    'Failed to verify MFA code. Please check your code and try again.',
  'invalid-totp-code-format':
    'Please enter a valid 6-digit verification code.',
  'invalid_totp_code':
    'Invalid verification code. Please try again.',
  'errors-mfa-verification-failed':
    'Failed to verify MFA code. Please check your code and try again.',
  'errors-mfa-not-setup':
    'MFA is not set up for your account. Please complete MFA setup first.',
  'errors-mfa-session-error':
    'MFA session error. Please try logging in again.',
  'errors-invalid-totp-code':
    'Invalid verification code. Please try again.',
  'errors-unauthorized':
    'Your session has expired. Please log in again.',
  'errors-unexpected':
    'An unexpected error occurred. Please try again.',
  'errors-user-not-found':
    'User not found. Please check your credentials.',
  'errors-too-many-attempts':
    'Too many failed attempts. Please try again later.',
  'errors-rate-limited':
    'Request rate limited. Please wait before trying again.',
  'errors-internal-error':
    'Internal server error. Please try again later.',
  'errors-mfa-setup-failed':
    'MFA setup failed. Please check your code and try again.',
};

export const alertFr = {
  'invalid-username-format-error': 'Format du nom d\'utilisateur invalide',
  'invalid-password-format-error': ' Format du mot de passe invalide',
  'invalid-cuurent-password-format-error': 'Format de mot de passe actuel invalide',
  'errors-current-password-required': 'Le mot de passe actuel est requis',
  'errors-incorrect-current-password':
    'Mot de passe actuel incorrect, veuillez réessayer.',
  'errors-password-previously-used':
    'Veuillez créer un mot de passe que vous n\'avez pas déjà utilisé.',
  'invalid-password-confirmation-error':
    'Le mot de passe et la confirmation du mot de passe ne correspondent pas',
  'missing-username-error':
    'Veuillez passer votre nom d\'utilisateur avant de soumettre le formulaire',
  'invalid-form-submit-error':
    'Le formulaire contient des entrées non valables ou vides, veuillez les corriger avant de soumettre',
  'register-cardholder-failed-alert':
    'Le titulaire de la carte n\'a pas été enregistré, veuillez réessayer',
  'register-cardholder-success-alert':
    'Carte enregistrée avec succès, connexion...',
  'password-reset-success-alert':
    'Le mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter en utilisant votre nouveau mot de passe',
  'login-failed-error': 'Échec de la connexion de l\'utilisateur',
  'exceeds-available-amount-alert':
    'Le montant du transfert dépasse le solde disponible du compte.',
  'refresh-failed-error':
    'Échec de l\'actualisation de la session. Veuillez réessayer ou attendre d\'être déconnecté.',
  'pin-retrieve-error':
    'Erreur lors de la récupération du code PIN. Veuillez réessayer ou contacter votre gestionnaire de compte si vous continuez à rencontrer des problèmes.',
  'account_locked':
    'Le compte est verrouillé en raison de tentatives échouées. Réessayez dans {time}',
  'invalid_credentials':
    'Nom d\'utilisateur ou mot de passe invalide. {attempts} tentatives restantes',
  'mfa-status-failed':
    'Échec de la récupération du statut MFA. Veuillez réessayer.',
  'mfa-setup-failed':
    'Échec de la configuration MFA. Veuillez vérifier votre code et réessayer.',
  'mfa-verification-failed':
    'Échec de la vérification du code MFA. Veuillez vérifier votre code et réessayer.',
  'invalid-totp-code-format':
    'Veuillez entrer un code de vérification à 6 chiffres valide.',
  'invalid_totp_code':
    'Code de vérification invalide. Veuillez réessayer.',
  'errors-mfa-verification-failed':
    'Échec de la vérification du code MFA. Veuillez vérifier votre code et réessayer.',
  'errors-mfa-not-setup':
    'MFA n\'est pas configuré pour votre compte. Veuillez d\'abord compléter la configuration MFA.',
  'errors-mfa-session-error':
    'Erreur de session MFA. Veuillez essayer de vous reconnecter.',
  'errors-invalid-totp-code':
    'Code de vérification invalide. Veuillez réessayer.',
  'errors-unauthorized':
    'Votre session a expiré. Veuillez vous reconnecter.',
  'errors-unexpected':
    'Une erreur inattendue s\'est produite. Veuillez réessayer.',
  'errors-user-not-found':
    'Utilisateur non trouvé. Veuillez vérifier vos identifiants.',
  'errors-too-many-attempts':
    'Trop de tentatives échouées. Veuillez réessayer plus tard.',
  'errors-rate-limited':
    'Taux de demande limité. Veuillez attendre avant de réessayer.',
  'errors-internal-error':
    'Erreur interne du serveur. Veuillez réessayer plus tard.',
  'errors-mfa-setup-failed':
    'Échec de la configuration MFA. Veuillez vérifier votre code et réessayer.',
};
